import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DeslindePage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
        <button onClick={() => navigate(-1)} className="text-sm text-zl-orange mb-4 hover:underline">&larr; Volver</button>
        <h1 className="text-2xl sm:text-3xl font-bold mb-6">Deslinde Legal</h1>
        <div className="bg-white rounded-lg p-6 sm:p-8 space-y-6 text-sm text-gray-700 leading-relaxed">
          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Deslinde de Responsabilidad</h2>
          <p><strong>TrendyShop de Mexico S. de R.L. de C.V.</strong>, operadora de la plataforma Zona Libre, se deslinda de cualquier responsabilidad derivada de las operaciones comerciales realizadas entre compradores y vendedores a traves de la plataforma.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Productos de Terceros</h2>
          <p>Los productos publicados en Zona Libre son ofrecidos por vendedores independientes. La Empresa no verifica, garantiza ni se responsabiliza por: la calidad, autenticidad, legalidad o seguridad de los productos; ni por el cumplimiento de las obligaciones asumidas por los vendedores.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Contenido Generado por Usuarios</h2>
          <p>Las opiniones, preguntas, respuestas y calificaciones son responsabilidad exclusiva de los usuarios que las generan. La Empresa se reserva el derecho de moderar o eliminar contenido que considere inapropiado.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Servicio de Entrega</h2>
          <p>Los servicios de entrega son proporcionados por repartidores independientes. TrendyShop de Mexico S. de R.L. de C.V. actua como plataforma de conexion y no mantiene relacion laboral con los repartidores registrados.</p></section>

          <p className="text-xs text-gray-400 border-t pt-4">TrendyShop de Mexico S. de R.L. de C.V. — Propietaria de la marca Zona Libre</p>
        </div>
      </div>
    </div>
  );
}
